import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../components/GlobalCardComponent";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PersonIcon from "@mui/icons-material/Person";
import GppGoodIcon from "@mui/icons-material/GppGood";
import PublicIcon from "@mui/icons-material/Public";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import StarIcon from "@mui/icons-material/Star";
import { useSearchParams } from "react-router-dom";
import SapResourcecComp from "./SapResourcecComp";
import GradeComp from "./GradeComp";
import TimeLineCom from "./TimeLineCom";
import BlogCards from "../BlockCards";
import SapPlan from "./SapPlan";
export default function SapContennt() {
  const [testTypeContent, setTestTypeContent] = useState({});
  const [testDetails, setTestDetails] = useState(null);
  const [searchParams] = useSearchParams();
  const testName = searchParams.get("test"); // This will get the value from ?test=...

  useEffect(() => {
    const storedData = localStorage.getItem("testDetails");
    if (storedData) {
      setTestDetails(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    switch (testName) {
      case "Under Graduate":
        setTestTypeContent({
          title: "Study Abroad Programs for Undergraduates",
          shortName: "Under Graduate",
          description:
            "We help students discover the right course and university, build strong profiles, and make the transition to studying abroad stress-free. From career guidance to visas, SAP is your step-by-step partner for global education.",

          features: [
            {
              icon: (
                <PersonIcon fontSize="medium" style={{ color: "#9D0385" }} />
              ),
              title: "End - To - End Mentoring",
              subtitle: "From psychometrics to visa",
            },
            {
              icon: (
                <GppGoodIcon fontSize="medium" style={{ color: "#9D0385" }} />
              ),
              title: "Transparent Guidance",
              subtitle: "No hidden fees, clear steps",
            },
            {
              icon: (
                <PublicIcon fontSize="medium" style={{ color: "#9D0385" }} />
              ),
              title: "Global Opportunities",
              subtitle: "USA, UK, Canada, Australia & more",
            },
          ],
          about: "About our Study Abroad Program",
          aboutContent:
            "A complete, step-by-step guidance system to prepare students for international education — from self-discovery to departure.",
          serviceSteps: [
            "Career & Interest Assessments to find your best path",
            "Course & University Shortlisting matched to budget & goals",
            "Application & Visa Assistance made simple",
            "Profile Building with projects, internships & activities",
            "Pre-departure Support: travel, stay, orientation",
          ],
          services: [
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (6).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Personalized Counselling",
              description:
                "One-on-one sessions to map strengths, preferences and long-term goals.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (7).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Psychometric & Aptitude Tests",
              description:
                "Science-backed assessments for career clarity and ideal course selection.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (8).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Profile Building",
              description:
                "Guidance for certifications, internships, projects and extracurriculars.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (9).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "University Selection",
              description:
                "Shortlists based on ranking, budget, eligibility and country fit.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (10).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Application Support",
              description:
                "Impactful SOPs / LORs, resume polish, documentation and submissions.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (11).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Visa & Pre-Departure",
              description:
                "Visa filing, travel, accommodation, insurance & cultural orientation.",
            },
          ],
        });
        break;

      case "Post Graduate":
        setTestTypeContent({
          title: "Study Abroad Programs for Postgraduates",
          shortName: "Post Graduate",
          description:
            "We guide graduates to find the right master’s or PhD programs, strengthen academic & research profiles, and secure global opportunities. From course shortlisting to scholarships and visa support, SAP ensures a seamless journey to your dream university.",

          features: [
            {
              icon: (
                <PersonIcon fontSize="medium" style={{ color: "#9D0385" }} />
              ),
              title: "Specialized Mentoring",
              subtitle: "Guidance for Master’s & PhD applicants",
            },
            {
              icon: (
                <GppGoodIcon fontSize="medium" style={{ color: "#9D0385" }} />
              ),
              title: "Career-Focused Approach",
              subtitle: "career & research aspirations.",
            },
            {
              icon: (
                <PublicIcon fontSize="medium" style={{ color: "#9D0385" }} />
              ),
              title: "Global Opportunities",
              subtitle: "USA, UK, Canada, Australia & more",
            },
          ],
          about: "About our Postgraduate Program",
          aboutContent:
            "A structured, end-to-end support system to help you pursue your master’s or doctoral degree abroad from course mapping to final departure.",
          serviceSteps: [
            "Career & Interest Assessments to find your best path",
            "Course & University Shortlisting matched to budget & goals",
            "Application & Visa Assistance made simple",
            "Profile Building with projects, internships & activities",
            "Pre-departure Support: travel, stay, orientation",
          ],
          services: [
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282791 (9).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Advanced Career Mapping",
              description:
                "In-depth guidance to align postgraduate specializations with your career goals.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282791 (10).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Research & Profile Building",
              description:
                "Support for research projects, publications, internships & leadership activities..",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282790 (12).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "University & Course Shortlisting",
              description:
                "Selection based on ranking, research fit, budget & country preferences.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282791 (11).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Application Excellence",
              description:
                "Crafting impactful SOPs, LORs, resumes & research proposals..",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282791 (12).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Scholarship & Funding Guidance",
              description:
                "Assistance with merit-based & need-based scholarships, assistantships & grants.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/TestTypeImages/Group 1171282791 (13).png"
                  width="100%"
                  height="100%"
                />
              ),

              title: "Visa & Pre-Departure Support",
              description:
                "Complete help with visas, accommodation, insurance & cultural orientation.",
            },
          ],
        });
        break;
    }
  }, [testDetails]);

  return (
    <>
      <GlobalCard>
        <Grid container spacing={4} px={3}>
          {/* left side */}
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12} sm={12} md={7} lg={7}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      display="inline-flex"
                      alignItems="center"
                      bgcolor="#5725750D" // light purple background
                      color="#6B1D8F" // deep purple text/icon
                      px={2}
                      py={0.5}
                      borderRadius={2}
                    >
                      <StarIcon sx={{ fontSize: 16, mr: 1 }} />
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 400,
                          fontSize: "14px",
                          fontStyle: "normal",
                          color: "#572575",
                        }}
                      >
                        Tailored For Your Success
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 400,
                        fontSize: "27px",
                        fontStyle: "normal",
                        color: "#572575",
                      }}
                    >
                      {testTypeContent?.title}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 400,
                        fontSize: "14px",
                        fontStyle: "normal",
                        color: "#333333",
                      }}
                    >
                      {testTypeContent?.description}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} container gap={2} mt={3}>
                    <Button
                      variant="contained"
                      startIcon={<PlayArrowIcon />}
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "13px",
                        fontWeight: 400,
                        backgroundColor: "#572575",
                        "&:hover": {
                          backgroundColor: "#572575",
                        },
                        textTransform: "none",
                        borderRadius: "24px",
                        paddingX: 2,
                      }}
                    >
                      Explore Program
                    </Button>

                    {/* Join SAP Now - Outlined Button */}
                    <Button
                      variant="outlined"
                      startIcon={<GroupAddIcon />}
                      sx={{
                        color: "#6A1B9A",
                        borderColor: "#6A1B9A",
                        fontSize: "13px",
                        textTransform: "none",
                        borderRadius: "24px",
                        paddingX: 3,
                        "&:hover": {
                          borderColor: "#4A148C",
                          color: "#4A148C",
                        },
                      }}
                    >
                      Join SAP Now
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={5} lg={5} textAlign="right">
                <Box
                  width="100%"
                  display="flex"
                  justifyContent={{
                    xs: "center", // for xs and sm, center
                    sm: "center",
                    md: "flex-end", // for md and above, right-align
                    lg: "flex-end",
                  }}
                  textAlign="right"
                >
                  <Box
                    height={220}
                    display="flex"
                    justifyContent={{
                      xs: "center", // for xs and sm, center
                      sm: "center",
                      md: "flex-end", // for md and above, right-align
                      lg: "flex-end",
                    }}
                  >
                    <img
                      src="/newdashboard/TestTypeImages/Group 1171282862 (4).png"
                      alt="student"
                      style={{
                        height: "100%",
                        objectFit: "contain",
                        maxWidth: "100%",
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <GlobalCard hovershadowEffect={true}>
              <Grid
                container
                spacing={4}
                justifyContent="space-between"
                alignItems="center"
              >
                {testTypeContent?.features?.map((feature, index) => (
                  <Grid item xs={12} sm={12} md={4} key={index}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box display="flex" alignItems="flex-start" gap={1}>
                        {/* ICON */}
                        <Box>
                          {" "}
                          {/* Small tweak to align it better vertically */}
                          {feature.icon}
                        </Box>

                        {/* Text Content: Title + Subtitle */}
                        <Box display="flex" flexDirection="column">
                          <Typography
                            fontFamily="'Inter', sans-serif"
                            fontWeight={400}
                            fontStyle="normal"
                            fontSize="18px"
                            color="#000000"
                          >
                            {feature.title}
                          </Typography>

                          <Typography
                            fontFamily="'Inter', sans-serif"
                            fontWeight={400}
                            fontStyle="normal"
                            fontSize="14px"
                            color="#333333"
                            mt={0.3}
                          >
                            {feature.subtitle}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </GlobalCard>
          </Grid>

          <Grid item xs={12} mt={2}>
            <Grid container spacing={2}>
              {/* left side content */}
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      fontFamily="'Inter', sans-serif"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="27px"
                      color="#572575"
                    >
                      {testTypeContent?.about}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="18px"
                      color="#222222"
                    >
                      {testTypeContent?.aboutContent}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <List>
                      {testTypeContent?.serviceSteps?.map((step, index) => (
                        <ListItem
                          key={index}
                          alignItems="flex-start"
                          disableGutters
                          sx={{ py: 0.2 }}
                        >
                          <ListItemIcon sx={{ minWidth: "24px" }}>
                            <FiberManualRecordIcon sx={{ fontSize: "8px" }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={step}
                            primaryTypographyProps={{
                              sx: {
                                fontFamily: "Inter",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontSize: "15px",
                                color: "#555555 !important",
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={5} lg={6} textAlign="right">
                <Box
                  width="100%"
                  display="flex"
                  justifyContent={{
                    xs: "center", // for xs and sm, center
                    sm: "center",
                    md: "flex-end", // for md and above, right-align
                    lg: "flex-end",
                  }}
                  textAlign="right"
                >
                  <Box
                    display="flex"
                    justifyContent={{
                      xs: "center", // for xs and sm, center
                      sm: "center",
                      md: "flex-end", // for md and above, right-align
                      lg: "flex-end",
                    }}
                  >
                    <img
                      src="/newdashboard/TestTypeImages/Group 1171282876.png"
                      alt="student"
                      style={{
                        height: "100%",
                        objectFit: "contain",
                        maxWidth: "100%",
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={7}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  fontFamily="'Inter', sans-serif"
                  fontWeight={400}
                  fontStyle="normal"
                  fontSize="27px"
                  color="#000000"
                >
                  Key Features of Our Study Abroad Program
                </Typography>

                <Typography
                  fontFamily="Inter"
                  fontWeight={400}
                  fontStyle="normal"
                  fontSize="15px"
                  color="#444444"
                >
                  Everything you need to prepare for a global education journey,
                  in one place.
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={5} textAlign="end">
            <Button
              variant="contained"
              startIcon={
                <img src="/newdashboard/TestTypeImages/raphael_chat.png" />
              }
              sx={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 400,
                backgroundColor: "#572575",
                "&:hover": {
                  backgroundColor: "#572575",
                },
                textTransform: "none",
                borderRadius: "24px",
                paddingX: 2,
              }}
            >
              Talk to a counseller
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={4}>
              {testTypeContent?.services?.map((item, index) => (
                <Grid item xs={12} sm={12} md={4} key={index} mt={1}>
                  <GlobalCard
                    height="100%"
                    textAlign="center"
                    hovershadowEffect={true}
                  >
                    <Box display="flex" justifyContent="center">
                      <Box height={55} width={55}>
                        {item.icon}
                      </Box>
                    </Box>
                    <Typography
                      mt={1}
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="18px"
                      color="#000000"
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      mt={1}
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="12px"
                      color="#313439"
                    >
                      {item.description}
                    </Typography>
                  </GlobalCard>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* <Grid item xs={12}>
  <TimeLineCom/>
 </Grid> */}

          <Grid item xs={12}>
            <Typography
              fontFamily="'Inter', sans-serif"
              fontWeight={400}
              fontStyle="normal"
              fontSize="27px"
              color="#000000"
            >
              Resources & Tools
            </Typography>

            <Typography
              fontFamily="Inter"
              fontWeight={400}
              fontStyle="normal"
              fontSize="15px"
              color="#444444"
            >
              Guides and tools to make every decision easier.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <SapResourcecComp />
          </Grid>

          {testName === "Under Graduate" && (
            <Grid item xs={12}>
              <GradeComp />
            </Grid>
          )}

          <Grid item xs={12}>
            <SapPlan/>
          </Grid>

          <Grid
            item
            xs={12}
            mt={2}
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
              },
            }}
          >
            <BlogCards />
          </Grid>
        </Grid>
      </GlobalCard>
    </>
  );
}
